module.exports = __webpack_public_path__ + "img/icon.0740522d.svg";